import {createShopifyImageUrl} from '@/utilities/create-shopify-image-url';
import classNames from 'classnames';

/**
 * Renders a rounded rectangular preview of an image in a carousel.
 * These are clickable and can be used to navigate to the corresponding slide.
 *
 * @param image - The image object to display.
 * @param isActive - Indicates whether the image is active.
 * @param onClick - The callback function to handle click events.
 * @returns  The rendered component.
 */
export default function CarouselImagePreviewSquare({
  image,
  isActive = false,
  onClick,
}: CarouselImagePreviewProps) {
  return (
    <button onClick={onClick}>
      <div
        key={image.url}
        className={classNames(
          'fast-transition size-12 md:size-16 overflow-hidden rounded-xl border',
          {
            'contrast-75 grayscale-[25%] filter': !isActive,
          }
        )}
      >
        <img
          src={createShopifyImageUrl(image.url, 64)}
          alt={`${image.alt ?? ''} Thumbnail`}
          className="size-full object-cover"
        />
      </div>
    </button>
  );
}

export type CarouselImagePreviewProps = {
  image: Image;
  isActive: boolean;
  onClick?: () => void;
};

type Image = {
  alt: string | null;
  url: string;
};
